module.exports = __webpack_public_path__ + "static/MailSculptHero-Joan-e4e6815985ac475fedbb18ec860cdc85.png";